import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { Card, CardContent } from "@babackapp/ui/components/card";
import useUpdatePortalBasics from "@babackapp/private-api-client/client/use-update-portal-basics";
import CustomerPortalBasicsForm from "./customer-portal-basics-form.tsx";
import { CustomerPortalFormValues } from "./use-customer-portal-basics-form.ts";

export default function CustomerPortalBasicsCard() {
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: update } = useUpdatePortalBasics(shop);

  const onSubmit = (data: CustomerPortalFormValues) => {
    return update({
      contactLink: data.contactLink,
      languages: data.languages,
      webOrderOnly: data.webOrderOnly,
      nonReturnableMetafieldItems: data.nonReturnableMetafieldItems,
      tagsForNotAcceptedOrder: data.tagsForNotAcceptedOrder,
      nonReturnableItems: data.nonReturnableItems,
      restockOnReturn: data.restockOnReturn,
      restockLocationId: data.restockLocationId ?? undefined,
      autoTreateOnLogisticianValidate: data.autoTreateOnLogisticianValidate,
      clientCanUpdatePersonalInformation:
        data.clientCanUpdatePersonalInformation,
      canCancelReturnRequest: data.canCancelReturnRequest,
      allowOnlyUniqueReturnRequest: data.allowOnlyUniqueReturnRequest,
      refundInitialShippingRule: data.refundInitialShippingRule,
      oneResolutionPerReturn: data.oneResolutionPerReturn,
      customerSegments: data.customerSegments,
      refundInitialShippingAmountRule: data.refundInitialShippingAmountRule,
    });
  };

  return (
    <Card className="w-full">
      <CardContent>
        <CustomerPortalBasicsForm
          onSubmit={onSubmit}
          workflowLogisticianActivated={shop.workflowLogistician.activated}
          defaultValues={{
            contactLink: shop.preferences.contactLink,
            languages: shop.preferences.languages,
            webOrderOnly: shop.preferences.webOrderOnly,
            canCancelReturnRequest: shop.preferences.canCancelReturnRequest,
            allowOnlyUniqueReturnRequest:
              shop.preferences.allowOnlyUniqueReturnRequest,
            nonReturnableMetafieldItems:
              shop.preferences.nonReturnableMetafieldItems,
            nonReturnableItems: shop.preferences.nonReturnableItems,
            tagsForNotAcceptedOrder: shop.preferences.tagsForNotAcceptedOrder,
            restockOnReturn: shop.preferences.restockOnReturn,
            restockLocationId: shop.preferences.restockLocationId ?? null,
            autoTreateOnLogisticianValidate:
              shop.preferences.autoTreateOnLogisticianValidate,
            clientCanUpdatePersonalInformation:
              shop.preferences.clientCanUpdatePersonalInformation,
            refundInitialShippingRule:
              shop.preferences.refundInitialShippingRule,
            oneResolutionPerReturn: shop.preferences.oneResolutionPerReturn,
            customerSegments: shop.preferences.customerSegments,
            singleArticleReturnOnly: shop.preferences.singleArticleReturnOnly,
            refundInitialShippingAmountRule:
              shop.preferences.refundInitialShippingAmountRule,
          }}
        />
      </CardContent>
    </Card>
  );
}
